<script>
export default {
    name: "ProcedureTab",

    data() {

        return {
            procedureDetails: {
                personnel: {},
                preoperationNotes: {},
                anaesthesiaNotes: {},
                operationNotes: {},
                postOperationNotes: {},
            },
        };
    },

    props: {

        procedures: Array,
    },

    components: {

        "view-procedure-details": () => import('@/components/commons/medical-file/procedures/ProcedureDetails.vue')
    },

    methods: {

        fetchProcedurePersonnel(procedure) {
            let url = `Theatre/GetPersonelnProcedureDetails`;
                url += `?ProcedureID=${procedure.procedureID}`;

            return this.$http.get(url).then(response => {
                this.procedureDetails.personnel = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchPreoperationNotes(procedure) {
            let url = `Theatre/GetPreOperativeNotesDetails`;
                url += `?ProcedureID=${procedure.procedureID}`;

            return this.$http.get(url).then(response => {
                this.procedureDetails.preoperationNotes = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchAnaesthetistNotes(procedure) {
            let url = `Theatre/GetAnaesthesiaNotesDetails`;
                url += `?ProcedureID=${procedure.procedureID}`;

            return this.$http.get(url).then(response => {
                this.procedureDetails.anaesthesiaNotes = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchOperationNotes(procedure) {
            let url = `Theatre/GetOperationNotesDetails`;
                url += `?ProcedureID=${procedure.procedureID}`;

            return this.$http.get(url).then(response => {
                this.procedureDetails.operationNotes = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchPostOperationNotes(procedure) {
            let url = `Theatre/GetPostOperationNotesDetails`;
            url += `?ProcedureID=${procedure.procedureID}`;

            return this.$http.get(url).then(response => {
                this.procedureDetails.postOperationNotes = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchProcedureDetails(proc) {
            this.$root.loading=true;
            return Promise.allSettled([
                    this.fetchPreoperationNotes(proc), this.fetchOperationNotes(proc), 
                    this.fetchAnaesthetistNotes(proc), this.fetchPostOperationNotes(proc), 
                    this.fetchProcedurePersonnel(proc),
                ]).then(() => { this.$root.loading=false; }).catch(() => { this.$root.loading=false; });
        },

        printMedicalFile() {
            window.print();
        },
    },
}
</script>
<template>
    <div class="w-full p-1 my-1">
        <div class="p-1 w-full bg-indigo-300 rounded-t-md">
            <h5 class="font-bold text-white text-sm">Visit #{{ $route.query.visitNo }}</h5>
        </div>
        <div class="w-full flex flex-wrap border-r-2 border-l-2 border-b-2 border-indigo-300 
            rounded-b p-2 bg-gray-100">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Id</th>
                        <th class="p-tiny">Procedure</th>
                        <th class="p-tiny">Req Date</th>
                        <th class="p-tiny">Req By</th>
                        <th class="p-tiny">Done</th>
                        <th class="p-tiny hide--print">Action</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="(procedure,idx) in procedures" :key="idx">
                        <td class="p-tiny">{{ procedure.procedureID }}</td>
                        <td class="p-tiny">{{ procedure.procedure }}</td>
                        <td class="p-tiny">{{ procedure.date | dateFormat }}</td>
                        <td class="p-tiny">{{ procedure.requestedBy }}</td>
                        <td class="p-tiny">{{ procedure.done ? `Done` : `Not Done` }}</td>
                        <td class="p-tiny hide--print">
                            <button 
                                @click.prevent="fetchProcedureDetails(procedure).then(() => {
                                    procedure.view=true;
                                })" class="btn-sm btn-info rounded">
                                    <i class="fa fa-eye"></i> View</button>
                            <view-procedure-details 
                                :procedure="procedure"
                                :procedureDetails="procedureDetails"
                                :showModal="procedure.view"
                                @closeModal="procedure.view=false"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-right">
            <button 
            @click.prevent="printMedicalFile"
            class="btn-sm btn-primary text-xs hide--print">
                <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
